function getDescriptionHTML(manufacturer, details) {
    "use strict";

    return `<div class="pull-left cart-modal__description">
        ${manufacturer}
        ${details}
    </div>`;
}

function renderProductDescription(manufacturer, details) {
    "use strict";

    return getDescriptionHTML(
        manufacturer ? '<div>' + manufacturer + '</div>' : '',
        details ? '<div>' + details + '</div>' : ''
    );
}

export default renderProductDescription;